import { useQuizBrowserBack } from './quizHistoryGuard';
import { AnswerSheetSidebarShimmer } from "./AnswerSheetShimmer";
import { QUIZ_ROUTES } from "./quizRoutes";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import AnswerTabs from "./AnswerTabs";
import { useQuizAnswerSheet } from "../../hooks/useQuizAnswerSheet";
import {
  buildQuizBackTarget,
  buildQuizFlowState,
  buildStartQuizState,
  getStoredQuizFlowState,
  persistQuizFlowState,
  navigateQuizBack,
  resolveQuizBackTarget,
} from "./quizFlowState";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import "./AnswerSheets.css";
import HeaderProfileSection from "../HeaderProfileSection";
import MyWalletSidebar from "../MyWalletSidebar";
import marksIcon from "../../assets/images/attempted.png";
import rankIcon from "../../assets/images/rank.png";
import timeIcon from "../../assets/images/time.png";

const AnswerSheets = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const persistedFlowState = useMemo(() => getStoredQuizFlowState(), []);
  const flowState = useMemo(
    () => buildQuizFlowState(location.state, persistedFlowState),
    [location.state, persistedFlowState],
  );
  const quizData = flowState?.quizData || {};
  const quizId = Number(
    quizData?.quizId || quizData?.quiz_id || quizData?.id || 0,
  );
  const statesId = Number(
    flowState?.state_id || quizData?.statesId || quizData?.states_id || 0,
  );
  const categoryId = Number(
    flowState?.category_id ||
      quizData?.categoryId ||
      quizData?.category_id ||
      0,
  );
  const assesmentBatchId = Number(flowState?.assesment_batch_id || 0);
  const startQuizState = useMemo(
    () => buildStartQuizState(flowState),
    [flowState],
  );
  const resolvedBackTarget = resolveQuizBackTarget(flowState, QUIZ_ROUTES.answerSheet, buildQuizBackTarget(QUIZ_ROUTES.start, startQuizState));
  useQuizBrowserBack(resolvedBackTarget);
  const answerSheetScreenState = useMemo(
    () =>
      buildQuizFlowState({
        ...flowState,
        quizBackTarget: resolvedBackTarget,
      }),
    [flowState, resolvedBackTarget],
  );
  const leaderboardNavigationState = useMemo(
    () =>
      buildQuizFlowState({
        ...answerSheetScreenState,
        quizBackTarget: buildQuizBackTarget(
          QUIZ_ROUTES.answerSheet,
          answerSheetScreenState,
        ),
      }),
    [answerSheetScreenState],
  );
  const resultAnalysisNavigationState = useMemo(
    () =>
      buildQuizFlowState({
        ...answerSheetScreenState,
        quizBackTarget: buildQuizBackTarget(
          QUIZ_ROUTES.answerSheet,
          answerSheetScreenState,
        ),
      }),
    [answerSheetScreenState],
  );

  useEffect(() => {
    persistQuizFlowState(answerSheetScreenState);
  }, [answerSheetScreenState]);

  const goBack = () => {
    navigateQuizBack(navigate, resolvedBackTarget);
  };

  const answerSheetQuery = useQuizAnswerSheet(
    {
      ...(statesId > 0 ? { states_id: statesId } : {}),
      category_id: categoryId,
      quiz_id: quizId,
      type: "all",
      assesment_batch_id: assesmentBatchId,
    },
    {
      enabled: quizId > 0 && categoryId > 0 && assesmentBatchId > 0,
    },
  );

  const quizStats = useMemo(
    () => [
      {
        icon: marksIcon,
        value: answerSheetQuery.data?.totalMarks || "0/0",
        label: "Marks",
      },
      {
        icon: rankIcon,
        value: answerSheetQuery.data?.rank || "-",
        label: "Rank",
        route: QUIZ_ROUTES.leaderboard,
      },
      {
        icon: timeIcon,
        value: answerSheetQuery.data?.timeTaken || "00:00:00",
        label: "Time Taken",
      },
    ],
    [answerSheetQuery.data],
  );

  const userName =
    answerSheetQuery.data?.quizDetail?.user_name ||
    flowState?.quiz_submission?.quiz_detail?.user_name ||
    "Student";



  const [activeAnswerTab, setActiveAnswerTab] = useState("all");

  const hasAnswerSheet = Boolean(answerSheetQuery.data) && !answerSheetQuery.isPlaceholderData;
  const isInitialLoading = !hasAnswerSheet && (answerSheetQuery.isLoading || answerSheetQuery.isFetching || answerSheetQuery.isPlaceholderData);
  const answerQuestions = answerSheetQuery.data?.questions || [];

  const answerCounts = {
    all: answerQuestions.length,
    correct: answerQuestions.filter((q) => q.status === "correct").length,
    incorrect: answerQuestions.filter((q) => q.status === "incorrect").length,
    unsolved: answerQuestions.filter((q) => q.status === "unsolved").length,
  };

  const answerFilters = [
    { id: "all", icon: "bi-list-check" },
    { id: "correct", icon: "bi-check-circle" },
    { id: "incorrect", icon: "bi-x-circle" },
    { id: "unsolved", icon: "bi-arrow-repeat" },
  ];
  return (
    <>
      <style>{`
        .homeDashboard-wrapper .page-content {
          padding-right: 0;
        }
       .homeDashboard-wrapper .main-content{
         height: 100vh;
         overflow: scroll;
         box-sizing: border-box;
         padding-bottom: 35px;
         min-height: 0;
         overflow-x: hidden !important;
       }
      .quizInstruction-Btn {
        bottom: 0px;
      }
     @media (max-width: 767px){
      .homeDashboard-wrapper .main-content {
         height: calc(100vh - 0px) !important;
         padding-bottom: 0px!important;
      }
      .instruction-main {
        min-height: calc(100vh - 0px);
        height: calc(100vh - 0px);
     }
      }
     `}</style>
      <HomeDashboardLayout showHeader={false}>
        <div className="qbl-page qbankList-page page-padding fixed-page-btn">
          <div className="start-quiz qbl-main instruction-main">
            <div className="hideProfile-page ">
              <div className="categories-page-header mb-0">
                <div>
                  <button
                    type="button"
                    className="categories-back-button"
                    onClick={goBack}
                  >
                    <i className="bi bi-chevron-left" />
                  </button>
                </div>
                <div>
                  <h4 className="d-flex categories-page-title">Answer Sheet</h4>
                </div>
                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>

            <div className="section-divide answerSheet-layout" aria-busy={isInitialLoading}>
              {/* LEFT SIDEBAR */}
              <div className="answerSheet-sidebar">
                {isInitialLoading ? <AnswerSheetSidebarShimmer /> : <div>
                  <h1 className="keep-title">Keep Trying, {userName}</h1>

                  <div className="keep-label">
                    Keep Practice, Keep Improving
                  </div>

                  {/* STATS */}
                  <div className="quizAnswer-stats">
                    {quizStats.map((stat) => (
                      <div className="answerSheet-statRow" key={stat.label}>
                        <span className="answerSheet-statLabel">
                          {stat.label}
                        </span>

                        {stat.route ? (
                          <button
                            type="button"
                            className="answerSheet-statValue answerSheet-rankLink"
                            onClick={() =>
                              navigate(stat.route, {
                                state: leaderboardNavigationState,
                              })
                            }
                          >
                            {stat.value}
                          </button>
                        ) : (
                          <strong className="answerSheet-statValue">
                            {stat.value}
                          </strong>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* BUTTONS */}
                  <div className="answerSheet-sidebarButtons">
                    <button
                      type="button"
                      className="answerSheet-blueBtn"
                      onClick={() =>
                        navigate(QUIZ_ROUTES.leaderboard, {
                          state: leaderboardNavigationState,
                        })
                      }
                    >
                      <i className="bi bi-trophy-fill" />
                      Leaderboard
                    </button>

                    <button
                      type="button"
                      className="answerSheet-blueBtn"
                      onClick={() =>
                        navigate(QUIZ_ROUTES.resultAnalysis, {
                          state: resultAnalysisNavigationState,
                        })
                      }
                    >
                      <i className="bi bi-clipboard-data"></i>
                      Result Analysis
                    </button>
                  </div>

                  {/* FILTERS */}
                  <div className="answerSheet-filterSection">
                    <h3 className="answerSheet-filterTitle">Filters</h3>

                    <div className="answerSheet-filterGrid">
                      {answerFilters.map((filter) => (
                        <button
                          key={filter.id}
                          type="button"
                          className={`answerSheet-filterBtn answerSheet-filter-${filter.id} ${
                            activeAnswerTab === filter.id ? "active" : ""
                          }`}
                          onClick={() => setActiveAnswerTab(filter.id)}
                        >
                          <i className={`bi ${filter.icon}`} />
                          <span>{answerCounts[filter.id]}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                }
                {/* BOTTOM BANNER */}
                {/* <div className="answerSheet-referBanner">
                </div> */}
              </div>

              {/* RIGHT SIDE */}
              <div className="answerSheet-content">
                {answerSheetQuery.isError && !hasAnswerSheet ? (
                  <div className="quiz-empty mt-3">
                    <i className="bi bi-exclamation-circle" />
                    <h3>Unable to load answer sheet</h3>
                    <p>
                      {answerSheetQuery.error?.message || "Please try again."}
                    </p>
                  </div>
                ) : (
                  <AnswerTabs
                    questions={answerQuestions}
                    isLoading={isInitialLoading}
                    activeTab={activeAnswerTab}
                    onTabChange={setActiveAnswerTab}
                    hideTabs={true}
                    enableGuessToggle={true}
                    guessPayloadBase={{
                      ...(statesId > 0 ? { states_id: statesId } : {}),
                      category_id: categoryId,
                      quiz_id: quizId,
                      assesment_batch_id: assesmentBatchId,
                    }}
                  />
                )}
              </div>
            </div>

            <div className="quizInstruction-Btn">
              <button
                type="button"
                className="start-quiz-btn"
                disabled={!hasAnswerSheet}
                onClick={() =>
                  navigate(QUIZ_ROUTES.resultAnalysis, {
                    state: resultAnalysisNavigationState,
                  })
                }
              >
                <span>Result Analysis</span>
              </button>
            </div>
          </div>

          <MyWalletSidebar withTopOffset={false} />
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default AnswerSheets;
